import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import Aboutsection from '../components/Aboutsection';
import PageMeta from '../components/PageMeta';

const Aboutpage = () => {
  return (
    <>
     <PageMeta
       title="About Us - GuestLinkup"
       description="Learn about GuestLinkup's mission to connect travelers with authentic family-run homestays across the Himalayan Northeast."
     />
     <Header />
               <Aboutsection />
          <Footer />
          </>
  )
}

export default Aboutpage